__webpack_require__.p = "https://www.ikea.com/gb/en/purchase-agent/cart-tmp/";